/**
 * Moldovan leu.
 */
export var MDL = {
  code: 'MDL',
  base: 10,
  exponent: 2
};